import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import TableLayout from "../../../components/TableLayout";
import CustomPagination from "../../../components/Common/CustomPagination";
import dataHandler from "../../../hooks/dataHandler";
import {
  ROLE_DELETE,
  ROLE_EDIT,
  ROLE_LIST,
  UPDATE_ROLE_STATUS,
} from "../../../services/ApiCalls";
import TableActions from "../../../components/Common/TableActions";
import moment from "moment";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import {
  AdminStatusOptionSubscription,
} from "../../../utilities/const";
import Filter from "../../../components/Common/Filter";
import Toggle from "../../../components/Common/Toggle";
import { useTranslation } from "react-i18next";

const Role = () => {
  const { t } = useTranslation();

  const roleData = JSON.parse(localStorage.getItem("roleDetail"));
  const permissions = roleData?.permissions?.[0] || {};
  const role = localStorage.getItem("role");

  const {
    body,
    searchHandler,
    deleteHandler,
    statusChangeHandler,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    total,
    loader,
    data,
    setBody,
  } = dataHandler({
    api: ROLE_LIST,
    dataToSet: (data) => data?.data,
  });

  const column = [
    {
      head: t("systemAccess.role"),
      accessor: "roleName",
      component: (item) => <>{item.roleName}</>,
    },
    {
      head: t("systemAccess.createdAt"),
      accessor: "cost",
      sortable: true,
      sortKey: "createdAt",
      component: (item) => (
        <>{moment(item?.createdAt).format("DD-MM-YYYY")}</>
      ),
    },
    {
      head: t("systemAccess.status"),
      accessor: "status",
      component: (item, key) => (
        <Toggle
          isChecked={item?.status === "Active"}
          onChange={() =>
            statusChangeHandler(
              () =>
                ROLE_EDIT({
                  _id: item._id,
                  status: item?.status === "Active" ? "Inactive" : "Active",
                }),
              key
            )
          }
        />
      ),
    },
    {
      head: t("systemAccess.actions"),
      accessor: "",
      isComponent: true,
      component: (item) => (
        <TableActions
          setDeleteModel={
            // permissions?.Role?.delete || role === "superAdmin"
            //   ?
            () => setDeleteModel({ show: true, dumpId: item?._id })
            // : undefined
          }
          editUrl={
            // permissions?.Role?.add_edit || role === "superAdmin"
            //   ?
            `/role/edit/${item?._id}`
            // : undefined
          }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel?.show}
        setConfirmation={() =>
          setDeleteModel((p) => ({ show: false, dumpId: "" }))
        }
        confirmHandler={() => {
          deleteHandler(() => ROLE_DELETE(deleteModel.dumpId));
        }}
      />

      <section className="ManageTeacher position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center justify-content-between gap-10">
                <h4 className="mb-0 py-3 fw-bold text-capitalize">
                  {t("systemAccess.roleList")}
                </h4>

                <Link
                  to={"/role/add"}
                  className="btn btn-primary d-flex align-items-center fw-sbold justify-content-center commonBtn"
                >
                  {t("systemAccess.addNew")}
                </Link>
              </div>
            </Col>

            <Row className="pl-4">
              <Filter
                body={body}
                searchHandler={searchHandler}
                setBody={setBody}
                statusFilterOptionArr={AdminStatusOptionSubscription}
              />
            </Row>

            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 rounded bg-white">
                <TableLayout
                  data={data}
                  column={column}
                  body={body}
                  setBody={setBody}
                  loader={loader}
                />
                <CustomPagination
                  body={body}
                  setBody={setBody}
                  pageChangeHandler={paginationHandler}
                  total={total}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Role;
